import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface OrderPageCardsDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function OrderPageCardsDialog({ open, onClose, onConfirm }: OrderPageCardsDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="order-page-cards-dialog-title"
      aria-describedby="order-page-cards-dialog-description"
    >
      <DialogTitle id="order-page-cards-dialog-title">Order page cards?</DialogTitle>
      <DialogContent>
        <DialogContentText id="order-page-cards-dialog-description">
          This will move all unlocked cards and clusters into rows and groups starting from the
          top-left of the board. Locked cards and groups will stay where they are.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} variant="contained">
          Order cards
        </Button>
      </DialogActions>
    </Dialog>
  );
}
